module.exports = __webpack_public_path__ + "static/media/correctCanLeadToStroke.fe1ee431.mp3";